export const ISRESULT = 'ISRESULT';

//Menu
export const GET_DATA_MENU_ALL = 'GET_DATA_MENU_ALL';
export const GET_DATA_MENU_ALL_SUCCEEDED = 'GET_DATA_MENU_ALL_SUCCEEDED';
export const REQUERT_MENU_ALL_FAILED = 'GET_DATA_MENU_ALL_FAILED';
export const SET_DATA_MENU = 'SET_DATA_MENU';

//Roles
export const GET_DATA_ROLES_ALL = 'GET_DATA_ROLES_ALL';
export const GET_DATA_ROLES_ALL_SUCCEEDED = 'GET_DATA_ROLES_ALL_SUCCEEDED';
export const REQUERT_ROLES_ALL_FAILED = 'GET_DATA_ROLES_ALL_FAILED';

//MenuRoles

export const GET_DATA_MENU_ROLES = 'GET_DATA_MENU_ROLES';
export const GET_DATA_MENU_ROLES_SUCCEEDED = 'GET_DATA_MENU_ROLES_SUCCEEDED';
export const DELETE_DATA_MENU_ROLES = "DELETE_DATA_MENU_ROLES";
export const REQUERT_MENU_ROLES_FAILED = 'GET_DATA_MENU_ROLES_FAILED';
export const SET_DATA_MENU_ROLES = 'SET_DATA_MENU_ROLES';



